import React from "react";
import { object, string, array } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";

import VideosLogo from "../../atoms/icons/videos-logo";
import CardImage from "../../atoms/cardimage";
import CustomStoryCard3 from "../../molecules/custom-story-card3";

import translate from "../../translate";
import { getCollectionSlug } from "../../utils/utils";

import "./videoScroller.m.css";

const VideoScroller = ({ collection, publisherName, pageType, sections }) => {
  const stories = collection.items
    .filter((item) => item.type === "story" && item.story && item.story["story-template"] === "video")
    .map((item) => item.story);

  if (!stories.length) {
    return null;
  }

  const getCollectionName = () => {
    if (pageType === "home-page") {
      return translate(publisherName, "videos");
    }

    return collection.name;
  };

  const getSlug = () => {
    if (pageType === "home-page") {
      return "/videos";
    }

    return getCollectionSlug(collection, sections);
  };

  return (
    <div styleName="container">
      <div styleName="wrapper" className="container">
        <Link href={getSlug()} styleName="video-logo-wrapper" id="video-collection">
          <VideosLogo />
          <div styleName="collection-name">{getCollectionName()}</div>
        </Link>

        <div styleName="content">
          <Link href={stories[0].url}>
            <CardImage
              story={stories[0]}
              imageType="image16x9"
              aspectRatio={[16, 9]}
              widths={[725]}
              eager={true}
              showAuthorName={false}
              showStoryTypeIcon
              showHeadline={true}
            />
          </Link>

          <p styleName="video-headline">{stories[0].headline}</p>

          <div styleName="stories">
            {stories.slice(1).map((story, index) => (
              <CustomStoryCard3
                key={index}
                story={story}
                imageType="image6x4"
                aspectRatio={[6, 4]}
                headerType={4}
                showStoryTypeIcon
                showHeadlineIcon
              />
            ))}
          </div>
        </div>

        <div styleName="show-more-wrapper">
          <Link href={getSlug()} styleName="show-more">
            {translate(publisherName, "show_more")}
          </Link>
        </div>
      </div>
    </div>
  );
};

VideoScroller.propTypes = {
  collection: object.isRequired,
  publisherName: string,
  currentPath: string,
  pageType: string,
  sections: array,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
  currentPath: get(state, ["qt", "currentPath"], null),
  pageType: get(state, ["qt", "pageType"], null),
  sections: get(state, ["qt", "config", "sections"], []),
});

export default connect(mapStateToProps, null)(VideoScroller);
